import { Navigate } from 'react-router-dom';
import LayoutPrincipal from '../layouts/LayoutPrincipal';
import LayoutCliente from '../layouts/LayoutCliente';
import LayoutHome from '../layouts/LayoutHome';
import LayoutDashBoard from '../layouts/LayoutDashBoard'
import Home from '../components/home/Home';
import CalendarioApp from '../components/calendario/CalendarioApp';
import TelaCliente from '../components/tela-cliente/TelaCliente';
import PasswordChange from '../components/login/PasswordChange';
import Dashboard from '../components/dashboard/Dashboard';
import NotFound from '../components/pageNotFound/notFound';
import React, { useRef, useEffect, useState } from 'react';
import PrivateRoute from '../components/ferramentas/PrivateRoute';


// Contexto para compartilhar as funções do CalendarioApp
export const CalendarioContext = React.createContext(null);

// Componente wrapper para CalendarioApp
const CalendarioAppWrapper = () => {
    // Referência para o componente CalendarioApp
    const calendarioRef = useRef(null);
    
    // Estado para compartilhar com o contexto
    const [contextValue, setContextValue] = useState({
        handleServicoClick: null,
        handleUsuarioClick: null,
        handlePerfilClick: null,
        accessLevel: null
    });

    // Atualiza o contexto quando as refs estiverem disponíveis
    useEffect(() => {
        if (calendarioRef.current) {
            setContextValue({
                handleServicoClick: calendarioRef.current.handleServicoClick,
                handleUsuarioClick: calendarioRef.current.handleUsuarioClick,
                handlePerfilClick: calendarioRef.current.handlePerfilClick,
                accessLevel: calendarioRef.current.accessLevel
            });
        }
    }, []);
    
    return (
        <CalendarioContext.Provider value={contextValue}>
            <CalendarioApp ref={calendarioRef} />
        </CalendarioContext.Provider>
    );
};

// Define route configurations as a constant
export const routes = [
    {
        path: '/',
        element: <LayoutHome />,
        children: [
            { index: true, element: <Home /> },
            { path: 'login', element: <Home logIn={true} /> },
            // { path: 'data', element: <Teste /> },
        ]
    },
    {
        path: '/cliente',
        element: <LayoutCliente />,
        children: [
            { index: true, element: <TelaCliente /> },
            { path: 'reset-password', element: <PasswordChange /> },
        ],
    },
    {
        path: '/admin',
        element: 
          <PrivateRoute>
            <LayoutPrincipal />
          </PrivateRoute>,
        children: [
            { index: true, element: <Navigate to="/admin/calendario" replace /> },
            { 
                path: 'calendario', 
                element: <CalendarioAppWrapper /> 
            },
            // Rotas de administração para usuários com acesso 'admin'
            // { 
            //     path: 'cadastraAdmin', 
            //     element: 
            //         <PrivateRoute requiredAccessLevels={['admin']}>
            //             {/* <CadastroAdmin /> */}
            //             <div>Cadastro Admin</div>
            //         </PrivateRoute> 
            // },
            // { 
            //     path: 'admins', 
            //     element: 
            //         <PrivateRoute requiredAccessLevels={['admin']}>
            //             {/* <Admin /> */}
            //             <div>Administradores</div>
            //         </PrivateRoute> 
            // },
            // // Outras rotas protegidas para qualquer usuário autenticado
            // { 
            //     path: 'cadastraServico', 
            //     element: 
            //         <PrivateRoute>
            //             {/* <CadastraServico /> */}
            //             <div>Cadastro de Serviço</div>
            //         </PrivateRoute> 
            // },
            // { 
            //     path: 'servico', 
            //     element: 
            //         <PrivateRoute>
            //             {/* <Servico /> */}
            //             <div>Serviços</div>
            //         </PrivateRoute> 
            // },
            // { 
            //     path: 'servicoInativo', 
            //     element: 
            //         <PrivateRoute>
            //             {/* <ServicoInativo /> */}
            //             <div>Serviço Inativo</div>
            //         </PrivateRoute>
            // },
            // { 
            //     path: 'editarPerfil', 
            //     element: 
            //         <PrivateRoute>
            //             {/* <EditarPerfil /> */}
            //             <div>Editar Perfil</div>
            //         </PrivateRoute>
            // },
        ],
    },    
    {
        path: '/admin/dashboard',
        element: <LayoutDashBoard />,
        children: [
            { index: true, element: <Dashboard /> },
        ],
    },
    {
        path: '*',
        element: <LayoutCliente />,
        children: [
            { path: '*', element: <NotFound /> },
        ],
    },
];